import { render } from "./ContactCard.vue?vue&type=template&id=763f7b5a&scoped=true"
import script from "./ContactCard.vue?vue&type=script&lang=js"
export * from "./ContactCard.vue?vue&type=script&lang=js"

import "./ContactCard.vue?vue&type=style&index=0&id=763f7b5a&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-763f7b5a"]])

export default __exports__